import { render } from "./LagarComponent.vue?vue&type=template&id=37121b1c"
import script from "./LagarComponent.vue?vue&type=script&lang=js"
export * from "./LagarComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\anton\\Desktop\\cangas_de_narcea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__